<template>
  <v-card style="padding: 0 10px;" v-if="workspaceID">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="6"
      >
        <h3>Share content</h3>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        style="text-align:right;"
        v-if="allWorkspaces && shareWorkspaces"
      >
        <v-btn
          color="primary"
          dark
          @click="handleShowDialog"
          small
        >
          Configurar
        </v-btn>
        <share-form 
          :showDialog="showDialog"
          :workspaceID="workspaceID"
          :allWorkspaces="allWorkspaces"
          :shareWorkspaces="shareWorkspaces"
          :onRefresh="handleGetActive"
          :onClose="handleClose"
          :onSave="handleSave"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        style="text-align:right;"
        v-else
      >
        <v-btn
          color="primary"
          dark
          @click="handleShowDialog"
          small
          loading
        >
          Configurar
        </v-btn>
      </v-col>
      <v-col
        v-if="shareWorkspaces"
        cols="12"
        sm="12"
        md="12"
      >
        <small>
          {{shareWorkspaces.map(item => item.TargetName).join(', ')}}
        </small>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import api from '@/services/api'
import ShareForm from './form/Index'
export default {
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
  },
  components: {
    ShareForm,
  },
  data: () => ({
    showDialog: false,
    allWorkspaces: null,
    shareWorkspaces: null,
  }),
  watch: {
    workspaceID () {
      this.handleGetActive()
    },
  },
  mounted () {
    this.handleGetAllWorkspace()
    this.handleGetActive()
  },
  methods: {
    handleShowDialog () {
      this.showDialog = true
    },
    handleGetAllWorkspace () {
      api.getAllWithoutLimit ('dviewcontent', `v1/system/workspaces/`)
        .then(response => {             
          this.allWorkspaces = response.data.map(item => {
            return {
              ID: item.ID,
              Name: item.Name
            }
          })
        })
    },
    handleGetActive () {
      api.getAll ('dviewcontent', `v1/system/workspaces/${this.workspaceID}/share-content`, 0, 1000, '')
        .then(response => {             
          this.shareWorkspaces = response.map(item => {
            item.ident = { id: item.ID, name: item.TargetName}
            return item
          })
        })
    },
    handleClose () {
      this.showDialog = false
    },
    handleSave (v) {
      console.log(v)
      /*
      api.updateItem ('dviewcontent', `v1/system/workspaces/`, `${this.workspaceID}/share-content-config`, v)
        .then(() => {             
          this.activeWorkspaces = v
          this.handleClose()
        })
      */
    },
    handleEdit () {
      this.showDialog = true
    },
  },
}
</script>

